import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Dropdown } from "antd";
import { DownOutlined, KeyOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useSession } from "../../session/SessionContext";
import ChangePasswordModal from "./ChangePasswordModal";

const AccountMenu: React.FC = () => {
  const { user, signOut } = useSession();
  const navigate = useNavigate();
  const [changingPassword, setChangingPassword] = useState(false);

  return (
    <>
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            { key: "password", icon: <KeyOutlined />, label: "Change password" },
            { key: "signOut", icon: <LogoutOutlined />, label: "Sign out" },
          ],
          onClick: ({ key }) => {
            if (key === "password") {
              setChangingPassword(true);
            } else {
              signOut();
              navigate("/login", { replace: true });
            }
          },
        }}
      >
        <Button icon={<UserOutlined />}>
          {user?.email} <DownOutlined />
        </Button>
      </Dropdown>
      <ChangePasswordModal open={changingPassword} onClose={() => setChangingPassword(false)} />
    </>
  );
};

export default AccountMenu;
